/**
 * Deteccion del entorno de ejecucion (Req. 2.6).
 *
 * HALLAZGO CRITICO DE iOS:
 *
 *   Una aplicacion agregada a la pantalla de inicio NO comparte IndexedDB,
 *   localStorage ni cookies con Safari. Son dos almacenamientos distintos.
 *
 * Consecuencia operativa, y es la regla mas importante de uso:
 *
 *   Toda la captura real debe hacerse en la APP INSTALADA. Lo que se escriba
 *   abriendo la pagina en Safari no aparecera en la app instalada, ni al
 *   contrario.
 *
 * Es la causa mas probable de un falso "se perdieron mis datos", asi que la
 * aplicacion detecta desde donde se abrio y avisa.
 */

export interface Plataforma {
  esIOS: boolean;
  /** Safari de escritorio o movil, excluyendo navegadores basados en Chromium. */
  esSafari: boolean;
  /** true = corriendo como app instalada, no como pestana del navegador. */
  enStandalone: boolean;
  /** Navegador que no puede instalar PWAs en iOS (Chrome y Firefox en iOS). */
  esNavegadorSinInstalacionEnIOS: boolean;
}

export function detectarPlataforma(): Plataforma {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return {
      esIOS: false,
      esSafari: false,
      enStandalone: false,
      esNavegadorSinInstalacionEnIOS: false,
    };
  }

  const ua = navigator.userAgent;

  // El iPad moderno se reporta como Mac; se distingue por tener pantalla tactil.
  const esIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  const esChromiumEnIOS = /CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
  const esSafari = /Safari/.test(ua) && !/Chrome|Chromium|Android/.test(ua) && !esChromiumEnIOS;

  const enStandalone =
    window.matchMedia?.('(display-mode: standalone)').matches === true ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true;

  return {
    esIOS,
    esSafari,
    enStandalone,
    esNavegadorSinInstalacionEnIOS: esIOS && esChromiumEnIOS,
  };
}
